export default {
  ALPHABET_LIST: 1,
  RUBRICS: 2,
  RUSSIAN_EXPORTER: 3,
  PACKAGE_PLACEMENT: 4,
  AD_SERVICE: 5,
  PREVIEW: 6
};
